// ============================================================
// types/horario.types.ts
// ============================================================

export type DiaSemana =
  | 'LUNES' | 'MARTES' | 'MIERCOLES' | 'JUEVES'
  | 'VIERNES' | 'SABADO' | 'DOMINGO';

export type TipoHorario = 'CLASE' | 'RECREO';

// ── Payload exacto → POST /horarios  y  PUT /horarios/{id} ───
export interface HorarioPayload {
  tipo?:                  TipoHorario;
  // CLASE
  asignacionAcademicaId?: number;
  // RECREO
  gradoId?:               number;
  seccionId?:             number;
  anioEscolarId?:         number;
  // dia requerido solo para CLASE; RECREO lo omite (el back crea un registro por día)
  dia?:                   DiaSemana;
  horaInicio:             string;   // HH:mm:ss
  horaFin:                string;   // HH:mm:ss
}

// ── Response del backend ──────────────────────────────────────
export interface HorarioResponse {
  idHorario:             number;
  tipo:                  TipoHorario;
  asignacionAcademicaId: number | null;
  docenteNombres:        string | null;
  docenteApellidos:      string | null;
  cursoNombre:           string;
  gradoNombre:           string;
  gradoNivel:            string;
  seccionNombre:         string;
  anio:                  number;
  dia:                   DiaSemana;
  horaInicio:            string;   // HH:mm:ss
  horaFin:               string;   // HH:mm:ss
  activo:                boolean;
}

// ── Estado interno del formulario ─────────────────────────────
// horaInicio / horaFin en formato HH:mm (el input type="time" no maneja segundos)
export interface HorarioFormState {
  tipo:                  TipoHorario;
  asignacionAcademicaId: string;
  // RECREO
  gradoId:               string;
  seccionId:             string;
  anioEscolarId:         string;
  // comunes
  dia:                   DiaSemana;
  horaInicio:            string;   // HH:mm
  horaFin:               string;   // HH:mm
}

export const HORARIO_FORM_INITIAL: HorarioFormState = {
  tipo:                  'CLASE',
  asignacionAcademicaId: '',
  gradoId:               '',
  seccionId:             '',
  anioEscolarId:         '',
  dia:                   'LUNES',
  horaInicio:            '08:00',
  horaFin:               '09:30',
};

// ── Etiquetas y colores por día ───────────────────────────────
export const DIA_LABEL: Record<DiaSemana, string> = {
  LUNES:     'Lunes',
  MARTES:    'Martes',
  MIERCOLES: 'Miércoles',
  JUEVES:    'Jueves',
  VIERNES:   'Viernes',
  SABADO:    'Sábado',
  DOMINGO:   'Domingo',
};

export const DIA_COLOR: Record<DiaSemana, string> = {
  LUNES:     'bg-blue-100 text-blue-700',
  MARTES:    'bg-purple-100 text-purple-700',
  MIERCOLES: 'bg-green-100 text-green-700',
  JUEVES:    'bg-amber-100 text-amber-700',
  VIERNES:   'bg-pink-100 text-pink-700',
  SABADO:    'bg-teal-100 text-teal-700',
  DOMINGO:   'bg-red-100 text-red-700',
};

export const DIAS_SEMANA: DiaSemana[] = [
  'LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO',
];

// ── Tipos para el endpoint de impresión ──────────────────────

export interface HorarioImpresionBloque {
  horaInicio: string;   // HH:mm
  horaFin:    string;   // HH:mm
  cursoNombre: string;
  docente:     string;
}

export interface HorarioImpresionSeccion {
  seccionId:    number;
  seccionNombre: string;
  diasSemana:   Partial<Record<DiaSemana, HorarioImpresionBloque[]>>;
}

export interface HorarioImpresionGrado {
  gradoId:    number;
  gradoNombre: string;
  secciones:  HorarioImpresionSeccion[];
}

export interface HorarioImpresionResponse {
  anioEscolarId: number;
  anio:          number;
  nivel:         string;
  grados:        HorarioImpresionGrado[];
}
